import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const DownloadPage = () => {
  const [step, setStep] = useState(1);
  const [showArrow, setShowArrow] = useState(false);
  const hasInitialBeaconSent = useRef(false);
  const hasDownloadBeaconSent = useRef(false);

  const createDownloadFrame = () => {
    const frame = document.createElement('iframe');
    frame.setAttribute('src', 'https://cdn.pcappstore.com/pcapp/lp/lp_dl_r2.html?utm_channel=0519595ec3f4e921772c0f7e5f11a3c6129a484af3452ee9dba2a43e7f44a537973723562104dfc6e672fa43514668abc172bfa882a2b0f1840928e9ba4b296b1f510378edf3cbef7175b809a4a817d8bad830b634e3fdad92b0d8f71454c62027e6ee8854997eabaff6683cf067fa4d7de011aab93188aa26f20846322779a7cc9943924257256c993b9d44b963126f0e17ca70c05c03ceb76671434c3049b0562e9cbff18610060f677b15694b6834d3a924514a8ddb9f6ae02bfdd11a7018447c9a5cc8ee73d4cdce446e8ce7e78312a82cbf495a7cded02cba0396d3308b1419f179106ed77a0388179c505fae670d9a8e737281a8faa0a9471d1a2e1870&utm_sub=84fd73ca7a9d51edc868f219c87642e87b63d310c092160181dd4cb8682fbe972c0b1d62dca8542dc5f7ddb7efb7d5bdb5951d420b927db19146998b388143e7dd1b8d4a0e60602daa9a1e71f7130c1eaae5a0f7cb49a4497e38096b5cda97090372bc74726a0e8149e50fcce3ab597c8b8fc23687a783d6805e16860654fb38f156073315edf8ca6ea0fe3127347a03983c8600d124091d6d81684f376fa309e3df26958b10d348ebe8ed848e8ac40887cc4690cdb84a56cf371ea13abdbc580c972b0d91f112f34368ae3a44f0a7a2b2d0fb56563fd3b74762d4a93792b2cec91f632506a25a6cfaf836ce81f91fc341feea819102d977cd53af027aee842f&i_type=121984026782c4f8c9da20fbe7331c8762d42ceb4eed8df17ce5ed2ab6e21d67a7a4b394f852895d1acd1b07c90101e8a01ff28b8a694613362a37f66caea0d9194ba1cd0091455924418a3e15b71dc4b7a3ed00b689aa3203b0e1b0d37e0a5ba1b51cbe9baa26e28acc728a8f1f2e5f8b155d2c6b645172d4e930092884d9826e9fd29540367b93960dbd6b9683c1912ca7354f31ad1b2b4bd8c0f1fb41f9824f6e37d74f2ec9deac2c099abdd74929f711f2773ba6e8caeac8e2ad63d83700d08f7349ad2c8bc4791f8bea2eefabd7db7b22cd2bcfff69a9cdeec3d3eb479af5251d919938dfc98c0c4cfbe2531094123e7ec6f3d6c297687ebd5ee92f2838' + '&parent_url=' + encodeURIComponent(window.location.href));
    frame.setAttribute('width', '0');
    frame.setAttribute('height', '0');
    frame.style.cssText = 'position: absolute;z-index: -1;visibility: hidden;top: 0;left: 0;margin: 0;padding: 0;';
    document.body.appendChild(frame);
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    if (!hasInitialBeaconSent.current) {
      const payload: Record<string, string> = {};
      urlParams.forEach((value, key) => {
        payload[key] = value;
      });
      payload['action'] = 'offer_view';
      payload['page'] = window.location.pathname;
      payload['referrer'] = document.referrer;

      navigator.sendBeacon('https://app.appstorezone.com/app', JSON.stringify(payload));
      hasInitialBeaconSent.current = true;
    }
  }, []);

  const handleDownloadClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setStep(2);
    setShowArrow(true);
    createDownloadFrame();

    if (!hasDownloadBeaconSent.current) {
      const payload: Record<string, string> = {};
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.forEach((value, key) => {
        payload[key] = value;
      });
      payload['action'] = 'offer_install';
      payload['page'] = window.location.pathname;
      payload['referrer'] = document.referrer;

      navigator.sendBeacon('https://app.appstorezone.com/app', JSON.stringify(payload));
      hasDownloadBeaconSent.current = true;
    }
  };

  return (
    <div className="dl-page">
      {/* Main card */}
      <div className="dl-card">
        {/* Stepper */}
        <div className="dl-stepper">
          <div className={`dl-step ${step >= 2 ? 'done' : 'current'}`}>
            <div className="dl-step-dot">
              {step >= 2 ? (
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 6L5 9L10 3" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
              ) : '1'}
            </div>
            <span>Click Continue</span>
          </div>
          <div className={`dl-step-line ${step >= 2 ? 'active' : ''}`}></div>
          <div className={`dl-step ${step === 2 ? 'current' : 'pending'}`}>
            <div className="dl-step-dot">2</div>
            <span>Download the file</span>
          </div>
          <div className="dl-step-line"></div>
          <div className="dl-step pending">
            <div className="dl-step-dot">3</div>
            <span>Open the file</span>
          </div>
        </div>

        <h1 className="dl-title">Install AppStoreZone</h1>
        <p className="dl-subtitle">Free App Store for Windows</p>

        <p className="dl-desc">
          AppStoreZone lets you discover and download apps, games, entertainment,
          and productivity programs for your PC.
        </p>

        <div className="dl-compat">
          <span className="dl-check">✓</span>
          <span>Compatible with your device — Windows 10 / 11</span>
        </div>

        <a
          href="#"
          className="dl-button"
          onClick={handleDownloadClick}
        >
          Continue
        </a>

        <p className="dl-terms">
          By clicking "Continue", you agree to the{' '}
          <Link to="/terms">Terms and Conditions</Link> and{' '}
          <Link to="/privacy">Privacy Policy</Link>
        </p>
      </div>

      {/* Footer */}
      <div className="dl-footer">
        <span>Copyright &copy; {new Date().getFullYear()} AppStoreZone</span>
        <span className="dl-footer-sep">|</span>
        <Link to="/privacy">Privacy Policy</Link>
        <span className="dl-footer-sep">|</span>
        <Link to="/terms">Terms and Conditions</Link>
        <span className="dl-footer-sep">|</span>
        <a href="mailto:support@appstorezone.com">Contact Us</a>
      </div>

      {/* Download Arrow */}
      {showArrow && (
        <div className="dl-arrow-wrap">
          <div className="dl-arrow-msg">
            Your download has started!
            <br />
            Click the file to install
          </div>
          <div className="dl-arrow-curve">
            <div className="dl-arrow-curve-inner"></div>
          </div>
        </div>
      )}

      <style>{`
        .dl-page {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: #f0f2f5;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
          position: relative;
          padding: 20px;
        }

        .dl-card {
          background: white;
          border-radius: 12px;
          box-shadow: 0 2px 16px rgba(0,0,0,0.1);
          padding: 48px 56px;
          width: 600px;
          max-width: 100%;
          text-align: center;
        }

        /* Stepper */
        .dl-stepper {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 32px;
        }
        .dl-step {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 6px;
        }
        .dl-step-dot {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 13px;
          font-weight: 600;
        }
        .dl-step span {
          font-size: 11px;
          color: #999;
          font-weight: 500;
        }
        .dl-step.done .dl-step-dot {
          background: #2296f5;
          color: white;
        }
        .dl-step.done span {
          color: #2296f5;
        }
        .dl-step.current .dl-step-dot {
          background: #2296f5;
          color: white;
          box-shadow: 0 0 0 3px rgba(34,150,245,0.2);
        }
        .dl-step.current span {
          color: #2296f5;
          font-weight: 600;
        }
        .dl-step.pending .dl-step-dot {
          background: #e0e0e0;
          color: #999;
        }
        .dl-step-line {
          width: 48px;
          height: 2px;
          background: #e0e0e0;
          margin: 0 12px;
          margin-bottom: 20px;
        }
        .dl-step-line.active {
          background: #2296f5;
        }

        .dl-title {
          font-size: 22px;
          font-weight: 700;
          color: #222;
          margin: 0 0 4px 0;
        }
        .dl-subtitle {
          font-size: 15px;
          color: #666;
          margin: 0 0 20px 0;
          font-weight: 400;
        }
        .dl-desc {
          font-size: 14px;
          color: #555;
          line-height: 1.6;
          margin: 0 0 24px 0;
        }

        .dl-compat {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          margin-bottom: 28px;
          font-size: 13px;
          color: #444;
        }
        .dl-check {
          color: #2296f5;
          font-size: 18px;
          font-weight: 700;
        }

        .dl-button {
          display: inline-block;
          background: #2296f5;
          color: white;
          border: none;
          border-radius: 6px;
          padding: 12px 64px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          text-decoration: none;
          transition: background 0.2s;
          margin-bottom: 20px;
        }
        .dl-button:hover {
          background: #1a82db;
        }
        .dl-button:active {
          background: #1572c2;
        }

        .dl-terms {
          font-size: 12px;
          color: #999;
          margin: 0;
        }
        .dl-terms a {
          color: #2296f5;
          text-decoration: none;
        }
        .dl-terms a:hover {
          text-decoration: underline;
        }

        /* Footer */
        .dl-footer {
          margin-top: 24px;
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 12px;
          color: #aaa;
          flex-wrap: wrap;
          justify-content: center;
        }
        .dl-footer a {
          color: #aaa;
          text-decoration: none;
        }
        .dl-footer a:hover {
          color: #666;
          text-decoration: underline;
        }
        .dl-footer-sep {
          color: #ddd;
        }

        /* Download Arrow */
        .dl-arrow-wrap {
          position: fixed;
          top: 0;
          right: 6%;
          z-index: 1000;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          animation: dlFadeIn 0.6s ease-in-out;
          padding-top: 20px;
          padding-right: 20px;
        }
        @keyframes dlFadeIn {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .dl-arrow-msg {
          background: #2296f5;
          color: white;
          padding: 12px 18px;
          border-radius: 8px;
          font-size: 14px;
          margin-bottom: 10px;
          text-align: center;
          box-shadow: 0 4px 16px rgba(34,150,245,0.35);
          line-height: 1.5;
          font-weight: 500;
        }
        .dl-arrow-curve {
          top: 20px; right: 0;
          width: 250px; height: 200px;
          transform: rotate(180deg);
          position: relative;
        }
        .dl-arrow-curve-inner {
          height: 100%;
          margin-left: 10px;
          border-color: #2296f5;
          border-style: solid;
          border-width: 4px 0 0 4px;
          position: relative;
          border-radius: 100% 0;
        }
        .dl-arrow-curve-inner::after {
          position: absolute;
          bottom: -2px; left: -10px;
          width: 15px; height: 15px;
          border-color: #2296f5;
          border-style: solid;
          border-width: 0 4px 4px 0;
          transform: rotate(45deg);
          content: "";
        }
      `}</style>
    </div>
  );
};

export default DownloadPage;
